import { Roles } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box, Divider } from 'braid-design-system';

import { CAREER_HISTORY } from 'src/components/Router';
import { useAppConfig } from 'src/modules/appConfig';

import { useShareableProfile } from '../data';

import translations from './.vocab';

export const CareerHistory = () => {
  const { zone } = useAppConfig();
  const { shareableProfile, shareableProfileCardEmpty } = useShareableProfile();
  const { t } = useTranslations(translations);

  const roles = shareableProfile?.roles || [];

  return shareableProfileCardEmpty[CAREER_HISTORY] ? null : (
    <>
      <Box
        id={CAREER_HISTORY}
        paddingY="xxlarge"
        data-automation={CAREER_HISTORY}
      >
        <Stack space="large">
          <Heading level="2" align="left">
            {t('Career history')}
          </Heading>
          <Roles
            displayVariant="full-text-no-divider"
            roles={roles.map((role) => ({
              ...role,
              showReviewLink: false,
              confirmed: true,
              stillInRole: !role.to,
              zone,
              replaceUrlTextWithLinks: false,
            }))}
          />
        </Stack>
      </Box>
      <Divider weight="regular" />
    </>
  );
};
